var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Settings-menu" } }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "span",
        {
          staticClass: "md-icon",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.type === "title"
          ? _c("TitleSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-title-size": _vm.updateTitleSize,
                "update-text-align": _vm.updateTextAlign,
                "update-title-text": _vm.updateTitleText,
                "update-subtitle-text": _vm.updateSubTitleText,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "fullName"
          ? _c("FullNameSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label": _vm.updateFieldLabel,
                "update-label-align": _vm.updateLabelAlign,
                "update-first-name": _vm.updateFirstName,
                "update-last-name": _vm.updateLastName,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "email"
          ? _c("EmailSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-email": _vm.updateFieldEmail,
                "update-label-align-mail": _vm.updateLabelAlignMail,
                "update-alt-label-mail": _vm.updateAltLabelMail,
                "update-visibility": _vm.updateVisibility,
                "update-required": _vm.updateRequired,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "address"
          ? _c("AddressSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-address": _vm.updateFieldLabelAddress,
                "update-label-align-address": _vm.updateLabelAlignAddress,
                "update-field-address-line-1": _vm.updateFieldAddressLine1,
                "update-field-address-line-2": _vm.updateFieldAddressLine2,
                "update-field-district": _vm.updateFieldDistrict,
                "update-field-postal-code": _vm.updateFieldPostalCode,
                "update-field-state": _vm.updateFieldState,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "phone"
          ? _c("PhoneSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-phone": _vm.updateFieldPhone,
                "update-label-align-phone": _vm.updateLabelAlignPhone,
                "update-masked-phone": _vm.updateMaskedPhone,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "datePicker"
          ? _c("DatePickerSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-date-picker":
                  _vm.updateFieldLabelDatePicker,
                "update-label-align-date-picker":
                  _vm.updateLabelAlignDatePicker,
                "update-date-label-date-picker": _vm.updateDateLabelDatePicker,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "shortText"
          ? _c("ShortTextSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-short-text": _vm.updateFieldLabelShortText,
                "update-label-align-short-text": _vm.updateLabelAlignShortText,
                "update-alt-label-short-text": _vm.updateAltLabelShortText,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "longText"
          ? _c("LongTextSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-long-text": _vm.updateFieldLabelLongText,
                "update-label-align-long-text": _vm.updateLabelAlignLongText,
                "update-alt-label-long-text": _vm.updateAltLabelLongText,
                "update-visibility": _vm.updateVisibility,
                "update-required": _vm.updateRequired,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "paragraph"
          ? _c("ParagraphSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-margin-top": _vm.updateMarginTopParagraph,
                "update-margin-bottom": _vm.updateMarginBottomParagraph,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "signature"
          ? _c("SignatureSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label": _vm.updateSignatureFieldLabel,
                "update-align": _vm.updateSignatureAlign,
                "update-alt-label": _vm.updateSignatureAltLabel,
                "update-is-required": _vm.updateSignatureIsRequired,
                "update-canvas-width": _vm.updateSignatureCanvasWidth,
                "update-canvas-height": _vm.updateSignatureCanvasHeight,
                "update-stroke-color": _vm.updateSignatureStrokeColor,
                "update-stroke-width": _vm.updateSignatureStrokeWidth,
                "update-background-color": _vm.updateSignatureBackgroundColor,
                "update-border-color": _vm.updateSignatureBorderColor,
                "update-border-width": _vm.updateSignatureBorderWidth,
                "update-border-radius": _vm.updateSignatureBorderRadius,
                "update-show-clear-button": _vm.updateSignatureShowClearButton,
                "update-clear-button-text": _vm.updateSignatureClearButtonText,
                "update-placeholder": _vm.updateSignaturePlaceholder,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "captcha"
          ? _c("CaptchaSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-captcha-field-label": _vm.updateCaptchaFieldLabel,
                "update-captcha-align": _vm.updateCaptchaAlign,
                "update-captcha-placeholder": _vm.updateCaptchaPlaceholder,
                "update-captcha-is-required": _vm.updateCaptchaIsRequired,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "pagebreak"
          ? _c("PageBreakSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-pagebreak-align": _vm.updatePagebreakAlign,
                "update-pagebreak-next-button-text":
                  _vm.updatePagebreakNextButtonText,
                "update-pagebreak-previous-button-text":
                  _vm.updatePagebreakPreviousButtonText,
                "update-pagebreak-show-previous-button":
                  _vm.updatePagebreakShowPreviousButton,
                "update-pagebreak-show-next-button":
                  _vm.updatePagebreakShowNextButton,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "dropDownList"
          ? _c("DropDownListSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-drop-down-list":
                  _vm.updateFieldLabelDropDownList,
                "update-placeholder-drop-down-list":
                  _vm.updatePlaceholderDropDownList,
                "update-label-align-drop-down-list":
                  _vm.updateLabelAlignDropDownList,
                "update-alt-label-drop-down-list":
                  _vm.updateAltLabelDropDownList,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "singleChoice"
          ? _c("SingleChoiceSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-single-choice":
                  _vm.updateFieldLabelSingleChoice,
                "update-label-align-single-choice":
                  _vm.updateLabelAlignSingleChoice,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "multipleSelection"
          ? _c("MultipleSelectionSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-multiple-selection":
                  _vm.updateFieldLabelMultipleSelection,
                "update-label-align-multiple-selection":
                  _vm.updateLabelAlignMultipleSelection,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "number"
          ? _c("NumberSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-number": _vm.updateFieldLabelNumber,
                "update-label-align-number": _vm.updateLabelAlignNumber,
                "update-sub-label-number": _vm.updateSubLabelNumber,
                "update-required": _vm.updateRequired,
                "update-slug": _vm.updateSlug,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "hour"
          ? _c("HourSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-hour": _vm.updateFieldLabelHour,
                "update-label-align-hour": _vm.updateLabelAlignHour,
                "update-hour-label": _vm.updateHourLabel,
                "update-minute-label": _vm.updateMinuteLabel,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "spinner"
          ? _c("SpinnerSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-spinner": _vm.updateFieldLabelSpinner,
                "update-label-align-spinner": _vm.updateLabelAlignSpinner,
                "update-required": _vm.updateRequired,
                "update-visibility": _vm.updateVisibility,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "send"
          ? _c("SendSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-send-label": _vm.updateFieldLabelSend,
                "update-label-align-send": _vm.updateAlignmentSend,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "starRating"
          ? _c("StarRatingSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-star-rating":
                  _vm.updateFieldLabelStarRating,
                "update-alignment-star-rating": _vm.updateAlignmentStarRating,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "ratingScale"
          ? _c("RatingScaleSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-field-label-rating-scale":
                  _vm.updateFieldLabelRatingScale,
                "update-alignment-rating-scale": _vm.updateAlignmentRatingScale,
                "update-sub-label-one-rating-scale":
                  _vm.updateRatingScaleSubLabelOne,
                "update-sub-label-two-rating-scale":
                  _vm.updateRatingScaleSubLabelTwo,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "separationElement"
          ? _c("SeparationElementSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-separation-color": _vm.updateSeparationColor,
                "update-separator-style": _vm.updateSeparatorStyle,
                "update-separator-height": _vm.updateSeparatorHeight,
                "update-separator-bottom": _vm.updateSeparatorBottom,
                "update-separator-top": _vm.updateSeparatorTop,
                "update-separator-side": _vm.updateSeparatorSide,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "fileUpload"
          ? _c("FileUploadSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-file-label": _vm.updateFileLabel,
                "update-file-alt-label-one": _vm.updateFileAltLabelOne,
                "update-file-alt-label-two": _vm.updateFileAltLabelTwo,
                "update-file-align": _vm.updateFileAlign,
                "update-file-required": _vm.updateRequired,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "image"
          ? _c("ImageSettings", {
              attrs: { item: _vm.item },
              on: {
                "update-image-url": _vm.updateImageUrl,
                "update-image-width": _vm.updateImageWidth,
                "update-image-height": _vm.updateImageHeight,
                "update-image-align": _vm.updateImageAlign,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }